import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input, Select } from "antd";
import { context } from "./../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import ModalTags from "../GeoUnit/ModalTags";
import TextEditorModal from "../Place/TextEditorModal";
import PlaceLinkTag from "../Place/PlaceLinkTag";
// import TextEditorModal from "./TextEditorModal";
const ContentDetailForm = () => {
    const [form] = Form.useForm();
    const {
        setAddLinkPlace,
        setAddNamePlace,
        setAddUrlPlace,
        addNamePlace,
        setTextEditorShow,
        setPlaceFormTag,
        addKindLinkPlace,
        addUrlPlace,
        addLinkPlace,
        linkTags,
        setLinkTags,
        selectedProvince,
        setSelectedProvince,
        selectedCountry,
        setSelectedCountry,
        selectedCategoryId,
        setSelectedCategoryId,
        selectedCityId,
        setSelectedCityId,
        isProvinceSelected,
        setIsProvinceSelected,
        isCountrySelected,
        setIsCountrySelected,
        setIsCategorySelected,
        setSelectedSubCategoryId,
        editedProvince,
        editedCountry,
        editedCity,
        editedSubCategory,
        editedCategory,
        selectedPlaceProvinceId,
    } = useContext(context);
    const [provinces, setprovinces] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    useEffect(() => {
        http.get(`${config.parkopoloApi}/api/Category/content`)
            .then((res) => {
                setCategories(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Geopolitics/`)
            .then((res) => {
                setprovinces(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        if (selectedCategoryId && selectedCityId) {
            http.post(`${config.parkopoloApi}/api/Place/getTags`, {
                categoryId: selectedCategoryId,
                geopoliticsId: selectedCityId,
            })
                .then((res) => {
                    setPlaceFormTag(res.data.result);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        if (
            editedProvince &&
            ((selectedProvince?._id !== editedProvince?._id &&
                selectedCountry?._id !== editedCountry?._id) ||
                !selectedCountry ||
                !selectedProvince ||
                !selectedCityId ||
                !selectedCategoryId)
        ) {
            setIsCountrySelected(true);
            setIsProvinceSelected(true);
            setIsCategorySelected(true);
            setSelectedProvince(
                provinces?.find((p) =>
                    !selectedPlaceProvinceId
                        ? p._id === editedProvince?._id
                        : selectedPlaceProvinceId
                )
            );
            setSelectedCountry(
                selectedProvince?.county.find(
                    (c) => c._id === editedCountry?._id
                )
            );
            setSelectedCityId(editedCity?._id);
            setSelectedCategoryId(editedCategory?._id);
        }
    }, [
        selectedCategoryId,
        selectedCityId,
        provinces?.length,
        selectedCountry,
        selectedProvince,
    ]);
    const onNameChange = (e) => {
        setAddNamePlace(e.target.value);
    };
    const onLinkChange = (e) => {
        setAddLinkPlace(e.target.value);
    };
    const onUrlChange = (e) => {
        setAddUrlPlace(e.target.value);
    };
    const handleSelectProvince = (value) => {
        setIsProvinceSelected(true);
        setSelectedProvince(provinces.find((p) => p._id === value));
    };
    const handleSelectCountry = (value) => {
        setIsCountrySelected(true);
        setSelectedCountry(
            selectedProvince.county.find((c) => c._id === value)
        );
    };

    const handleSelectCity = (value) => {
        setSelectedCityId(value);
    };
    const handleSelectSubCategory = (value) => {
        setSelectedSubCategoryId(value);
    };
    const handleSelectCategory = (value) => {
        setIsCategorySelected(true);
        setSelectedCategoryId(value);
        http.get(`${config.parkopoloApi}/api/Category/subCategory/${value}`)
            .then((res) => {
                setSubCategories(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const linkName = form.getFieldValue("عنوان لینک");
    const linkAddress = form.getFieldValue("آدرس لینک");
    const handleAddLink = () => {
        const link = {
            title: addLinkPlace,
            url: addUrlPlace,
            kind: addKindLinkPlace,
        };
        const newLinks = linkTags.length > 0 ? [...linkTags] : [];
        newLinks.push(link);
        setLinkTags(newLinks);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "30px" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        style={{ width: "100%" }}
                    >
                        <Input
                            defaultValue={addNamePlace}
                            onChange={onNameChange}
                            placeholder="عنوان را وارد کنید"
                        />
                    </Form.Item>
                </div>

                <div style={{ display: "flex", gap: "30px" }}>
                    <Form.Item label="انتخاب استان" style={{ width: "100%" }}>
                        <Select
                            defaultValue={editedProvince?._id}
                            onSelect={handleSelectProvince}
                        >
                            {provinces?.map((p) => {
                                return (
                                    <Select.Option value={p._id} key={p._id}>
                                        {p.province}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item label="انتخاب شهرستان" style={{ width: "100%" }}>
                        <Select
                            defaultValue={editedCountry?._id}
                            onSelect={handleSelectCountry}
                            disabled={!isProvinceSelected}
                        >
                            {selectedProvince
                                ? selectedProvince.county.map((c) => {
                                      return (
                                          <Select.Option
                                              value={c._id}
                                              key={c._id}
                                          >
                                              {c.name}
                                          </Select.Option>
                                      );
                                  })
                                : null}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="انتخاب شهر/روستا"
                        style={{ width: "100%" }}
                    >
                        <Select
                            defaultValue={editedCity?._id}
                            onSelect={handleSelectCity}
                            disabled={!isCountrySelected}
                        >
                            {selectedCountry
                                ? selectedCountry.city.map((c, key) => {
                                      return (
                                          <Select.Option
                                              value={c._id}
                                              key={c._id}
                                          >
                                              {c.name}
                                          </Select.Option>
                                      );
                                  })
                                : null}
                            {selectedCountry
                                ? selectedCountry.village.map((c, key) => {
                                      return (
                                          <Select.Option
                                              value={c._id}
                                              key={key}
                                          >
                                              {c.name}
                                          </Select.Option>
                                      );
                                  })
                                : null}
                        </Select>
                    </Form.Item>
                </div>
                <div style={{ display: "flex", gap: "30px" }}>
                    <Form.Item
                        label="انتخاب دسته بندی"
                        style={{ width: "100%" }}
                    >
                        <Select
                            defaultValue={editedCategory?._id}
                            onSelect={handleSelectCategory}
                        >
                            {categories.map((c) => {
                                return (
                                    <Select.Option value={c._id} key={c._id}>
                                        {c.name}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="انتخاب زیر دسته"
                        style={{ width: "100%" }}
                    >
                        <Select
                            defaultValue={editedSubCategory}
                            onSelect={handleSelectSubCategory}
                            disabled={true}
                        >
                            {subCategories.map((c) => {
                                return (
                                    <Select.Option value={c._id} key={c._id}>
                                        {c.name}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="عنوان لینک"
                        label="عنوان لینک"
                        style={{ width: "100%" }}
                    >
                        <Input
                            onChange={onLinkChange}
                            placeholder="عنوان لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        <Input
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        label="انتخاب نوع لینک"
                        style={{ width: "100%" }}
                    >
                        <Select defaultValue={"web"}>
                            <Select.Option value="web">web</Select.Option>
                            <Select.Option value="twitter">
                                Twitter
                            </Select.Option>
                            <Select.Option value="telegram">
                                Telegram
                            </Select.Option>
                            <Select.Option value="insta">
                                Instagram
                            </Select.Option>
                        </Select>
                    </Form.Item>
                    <Button
                        onClick={handleAddLink}
                        disabled={!linkName || !linkAddress}
                    >
                        اضافه کردن لینک جدید
                    </Button>
                </div>
                <PlaceLinkTag tags={linkTags} />

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="addPlace" />
                    </div>
                </Form.Item>
                <Form.Item name="ویرایشگر متن">
                    <Button
                        onClick={() => setTextEditorShow(true)}
                        type="primary"
                    >
                        ویرایشگر متن
                    </Button>
                </Form.Item>
            </Form>
            <TextEditorModal />
        </div>
    );
};

export default ContentDetailForm;
